import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { type UpdateUserCompanyAccessPayload } from "@qivia/schemas-companies";
import { QueryStatus, authAxios } from "../../utils";
import { RootState } from "../../redux/store";

export interface DebugAccountState {
  updateUserCompanyAccessStatus: QueryStatus;
}

const initialState: DebugAccountState = {
  updateUserCompanyAccessStatus: "idle",
};

export const updateUserCompanyAccessAsync = createAsyncThunk(
  "updateUserCompanyAccess/call",
  async (payload: UpdateUserCompanyAccessPayload) => {
    const axios = authAxios();
    await axios.post(`/users/update_company_access`, payload);
  },
);

export const debugAccountSlice = createSlice({
  name: "debugAccount",
  initialState,
  reducers: {
    resetUpdateUserCompanyAccessStatus: (state) => {
      state.updateUserCompanyAccessStatus = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateUserCompanyAccessAsync.pending, (state) => {
        state.updateUserCompanyAccessStatus = "processing";
      })
      .addCase(updateUserCompanyAccessAsync.fulfilled, (state) => {
        state.updateUserCompanyAccessStatus = "success";
      })
      .addCase(updateUserCompanyAccessAsync.rejected, (state) => {
        state.updateUserCompanyAccessStatus = "failed";
      });
  },
});

export const selectUpdateUserCompanyAccessStatus = (state: RootState) =>
  state.debugAccount.updateUserCompanyAccessStatus;

export default debugAccountSlice.reducer;
